var render = function render(_c,_vm){return (!_vm.props.close)?_c('mm-alert',{attrs:{"type":"success","global":"","center":"","show-icon":""},on:{"close":_vm.props.onchange}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('message.auth.pass'),expression:"'message.auth.pass'"}],attrs:{"slot":"title"},slot:"title"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }